import UrlUtils from '../common/utils/url';


export default class TopUI{

    constructor() {
        this._init();
    }

    _init(){

        // 残りのプレイ回数を増やす
        const query = UrlUtils.getQuery() || {};
        if(query.count && parseInt(query.count)){
            const playLimit = DATA.getData('playLimit');
            playLimit.count = query.count;
            window.DATA.setData('playLimit', playLimit);
        }

        //this._setStartLink();
        this._setPlayCount();
    }

    _setStartLink(){
        const isFirst = window.DATA.getData('isFirst');

        if(isFirst == 0){
            document.querySelector('.top__btnlist__item.-start a').setAttribute('href', './howto/');
        }
    }
    
    _setPlayCount(){
        const playLimit = window.DATA.getData('playLimit');
        const $btnStart = document.querySelector('.top__btnlist__item.-start');
        
        if(playLimit.count === 0){
            $btnStart.classList.add('-disable');
        }
        else{
            $btnStart.querySelector('span').innerHTML = `(あと${playLimit.count}かい)`;
        }
    }
}
